import { createContext, FC, PropsWithChildren, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { createContextualCan, useAbility } from '@casl/react'
import { getUser } from 'redux/store/user/getters'
import { ability, defineAbility, DashboardAbility } from '../Abilities'
import { AnyAbility } from '@casl/ability'

export const DashboardAbilityContext = createContext<DashboardAbility>(ability)

const DashboardAbilityProvider: FC<PropsWithChildren> = ({ children }) => {
  const user = useSelector(getUser)

  const ability = useMemo(() => defineAbility(user), [user])

  return (
    <DashboardAbilityContext.Provider value={ability}>
      {children}
    </DashboardAbilityContext.Provider>
  )
}

export const useDashboardAbility = () =>
  useAbility<DashboardAbility>(DashboardAbilityContext)

export const Can = createContextualCan<AnyAbility>(
  DashboardAbilityContext.Consumer
)

export default DashboardAbilityProvider
